<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
      <!-- <mobile-menu></mobile-menu> -->
      <template  slot="links">
        <!-- <sidebar-item :link="{name: 'Dashboard', icon: 'nc-icon nc-chart-pie-35', path: '/admin/overview'}">
        </sidebar-item> -->
        <sidebar-item :link="{name: '倉儲', icon: 'nc-icon nc-app'}">
          <sidebar-item :link="{name: '料號設定', path: '/admin/items'}"></sidebar-item>
          <!-- <sidebar-item :link="{name: '出貨', path: '#'}"></sidebar-item> -->
        </sidebar-item>
        <sidebar-item :link="{name: '行銷', icon: 'nc-icon nc-bulb-63'}">
          <sidebar-item :link="{name: '銷售頁設定', path: '/admin/sale_groups'}"></sidebar-item>
          <sidebar-item :link="{name: '分類設定', path: '/admin/categories'}"></sidebar-item>
          <sidebar-item :link="{name: '貨號設定', path: '/admin/goods'}"></sidebar-item>
          <!-- <sidebar-item :link="{name: '電子信件', path: '#'}"></sidebar-item> -->
          <sidebar-item :link="{name: 'slider', path: '/admin/sliders'}"></sidebar-item>
          <sidebar-item :link="{name: '加購商品', path: '/admin/addpurchases'}"></sidebar-item>
          <sidebar-item :link="{name: '幣別', path: '/admin/currencies'}"></sidebar-item>
          <!-- <sidebar-item :link="{name: '簡訊', path: '#'}"></sidebar-item> -->
        </sidebar-item>
        <sidebar-item :link="{name: '訂單', icon: 'nc-icon nc-paper-2'}">
          <sidebar-item :link="{name: '訂單列表', path: '/admin/orders'}"></sidebar-item>
          <!-- <sidebar-item :link="{name: '退換貨', path: '#'}"></sidebar-item> -->
        </sidebar-item>
        <!-- <sidebar-item :link="{name: '會計', icon: 'nc-icon nc-money-coins'}">
          <sidebar-item :link="{name: '基本設定', path: '#'}"></sidebar-item>
          <sidebar-item :link="{name: '發票', path: '#'}"></sidebar-item>
          <sidebar-item :link="{name: '信用卡', path: '#'}"></sidebar-item>
          <sidebar-item :link="{name: '帳務', path: '#'}"></sidebar-item>
        </sidebar-item> -->
        <!-- <sidebar-item :link="{name: '版型&模組', icon: 'nc-icon nc-email-85'}">
          <sidebar-item :link="{name: '頁面版型', path: '#'}"></sidebar-item>
          <sidebar-item :link="{name: '模組', path: '#'}"></sidebar-item>
        </sidebar-item> -->
        <sidebar-item :link="{name: '基本設定', icon: 'nc-icon nc-single-02'}">
          <sidebar-item :link="{name: '使用者群組', path: '/admin/user_groups'}"></sidebar-item>
          <sidebar-item :link="{name: '使用者', path: '/admin/users'}"></sidebar-item>
          <sidebar-item :link="{name: '商店設定', path: '/admin/store'}"></sidebar-item>
          <sidebar-item :link="{name: '分店設定', path: '/admin/branches'}"></sidebar-item>
          <sidebar-item :link="{name: '語言', path: '/admin/languages'}" />
        </sidebar-item>
        <!-- <sidebar-item :link="{name: '系統LOG', icon: 'nc-icon nc-chart-bar-32', path: '#'}"></sidebar-item> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar :subName="subName" ></top-navbar>

      <dashboard-content @click.native="toggleSidebar" >
        
      </dashboard-content>
      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import UserMenu from './Extra/UserMenu.vue'
  export default {
    data() {
      return {
        subName: ''
      }
    },
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      UserMenu
    },
    methods: {
      setSubName(val) {
        this.subName = val
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
